/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

/**
 * The NoFill image
 */
export const NoFill = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    preserveAspectRatio="none"
    width="100%"
    height="100%">
    <path stroke-width="2" vector-effect="non-scaling-stroke" d="M0 0L48 48" />
  </svg>
);
